import React from "react";
import PropTypes from "prop-types";

export const Spinner = ({
                            size = "md",
                            color = "white",
                            className = "",
                            thickness = "border-2"
                        }) => {
    // Size variants
    const sizeMap = {
        xs: "w-3 h-3",
        sm: "w-4 h-4",
        md: "w-6 h-6",
        lg: "w-8 h-8",
        xl: "w-10 h-10"
    };

    // Color variants
    const colorMap = {
        white: "border-white/20 border-t-white",
        green: "border-[#57A863]/20 border-t-[#57A863]",
        gray: "border-gray-200 border-t-gray-600",
        primary: "border-[#57A863]/20 border-t-[#57A863]"
    };

    const spinnerSize = sizeMap[size] || sizeMap.md;
    const spinnerColor = colorMap[color] || colorMap.white;

    return (
        <div
            className={`inline-block ${spinnerSize} ${spinnerColor} ${thickness} rounded-full animate-spin ${className}`}
            style={{ borderBottomColor: 'transparent', borderLeftColor: 'transparent', borderRightColor: 'transparent' }}
            role="status"
            aria-label="Loading"
        >
            <span className="sr-only">Chargement en cours...</span>
        </div>
    );
};

Spinner.propTypes = {
    size: PropTypes.oneOf(["xs", "sm", "md", "lg", "xl"]),
    color: PropTypes.oneOf(["white", "green", "gray", "primary"]),
    className: PropTypes.string,
    thickness: PropTypes.string
};

export default Spinner;